import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  arrow: {
    color: '#535edb',
  },
}));
